import React from 'react';
import { LinkHighlightButton } from '../HighlightButton/HighlightButton';

import styles from '../../css/Music.module.css';

class Music extends React.Component {
  handleButtonClick = async (buttonTitle) => {
    const { logAnalyticsEvent } = await import('../../utils/analyticsUtils');
    logAnalyticsEvent('music_home_button_click', {
      button_title: buttonTitle
    });
  };

  render() {
    return (
      <main className="mainContainer centeredVertically centeredHorizontallyOnMobile">
        <section>
          <div className={styles.bannerContainer}>
            <img className={styles.bannerImage} src="/static/img/banner.webp" width="1200" height="148" alt="A section of blue and lavender tinted sheet music that Lawrence Luo composed" />
          </div>

          <p style={{ paddingTop: "1.85rem", paddingBottom: "1.6rem" }}>
            <b>Lawrence Luo</b> is an arranger, singer, and keyboard player based in San Francisco with nearly two decades of experience creating and performing music.
            His contemporary compositions and arrangements have garnered NACUSA and BOCA awards, and his work for chamber ensembles, jazz-funk combos, and a cappella groups are performed regularly in-concert.
          </p>

          <div>
            <div style={{ display: 'inline-block', boxSizing: 'border-box', marginRight: 10, marginBottom: 25 }}>
              <LinkHighlightButton
                to="/commissions"
                onClick={() => this.handleButtonClick('REQUEST A COMMISSION')}
              >
                COMMISSION
              </LinkHighlightButton>
            </div>

            <div style={{ display: "inline-block" }}>
              <LinkHighlightButton
                to="/work"
                onClick={() => this.handleButtonClick('BROWSE WORK')}
              >
                BROWSE WORK
              </LinkHighlightButton>
            </div>
          </div>
        </section>
      </main >
    )
  }
}

export default Music;
